import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/react"
import React, { useEffect, useMemo, useState } from "react"

const ChallanList = ({ data, handleSelChallan }) => {
    const [selChallanNo, setSelChallanNo] = useState("0")
    useEffect(() => {
        handleSelChallan(selChallanNo)
    }, [selChallanNo])
    const classNames = useMemo(
        () => ({
            //  wrapper: ["max-h-[382px]", "max-w-3xl"],
            th: ["text-center", "text-white", "bg-blue-700", "font-semibold", "h-auto", "py-2", "uppercase"],
            tr: ["hover:bg-gray-50", "hover:text-red-500",
                "border-b-0 ", "border-emerald-200", "font-semibold", "cursor-pointer"],
            td: ["text-xs", "font-semibold", "text-center"]
            
        }),
        [data],
    );
    return (
        <div className="p-5">
        <Table
            selectionMode="single"
            isHeaderSticky
            color={"danger"}
            selectedKeys={[String(selChallanNo)]}
            onSelectionChange={(e) => setSelChallanNo(Array.from(e)[0] ?? 0)}
            aria-label="ChallanList"
            removeWrapper={true}
            classNames={classNames}
           
        >
            <TableHeader>
                <TableColumn>Chal No</TableColumn>
                <TableColumn>Chal Date</TableColumn>
                <TableColumn>Net Amount</TableColumn>
            </TableHeader>
            <TableBody>
                {
                    data && data.length > 0 &&
                    data.map((ele) => {
                        return (
                            <TableRow className="border-1" key={ele.TransactionID}>
                                <TableCell>{ele?.Chal_no}</TableCell>
                                <TableCell>{ele?.Chal_Date}</TableCell>
                                <TableCell>{ele?.NetAmt}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </Table>
        </div>
    )

}
export default ChallanList